module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-VariableFont_wght.20e1565d.ttf";